import { render, staticRenderFns } from "./DialogWithTabsTitle.vue?vue&type=template&id=82513166&scoped=true&"
import script from "./DialogWithTabsTitle.vue?vue&type=script&lang=js&"
export * from "./DialogWithTabsTitle.vue?vue&type=script&lang=js&"
import style0 from "./DialogWithTabsTitle.vue?vue&type=style&index=0&id=82513166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82513166",
  null
  
)

export default component.exports